import { render, staticRenderFns } from "./aLiPay.vue?vue&type=template&id=4bb44990&scoped=true"
import script from "./aLiPay.vue?vue&type=script&lang=js"
export * from "./aLiPay.vue?vue&type=script&lang=js"
import style0 from "./aLiPay.vue?vue&type=style&index=0&id=4bb44990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb44990",
  null
  
)

export default component.exports